export default "__VITE_ASSET__4z1Q9XnI__"